import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { fetchOwners } from '../../../helpers/connect_api';
import { Button, Col, Row, Spinner } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/pro-regular-svg-icons';

export default function UnlockOwners({ insightsPropertyId, onUnlock }) {
  const [loading, setLoading] = useState(true);
  const [remainingCredits, setRemainingCredits] = useState();
  const [restrictedProperty, setRestrictedProperty] = useState(false);

  useEffect(() => {
    fetchOwners(insightsPropertyId)
      .then(results => onUnlock(results['connect/ownerships']))
      .catch((error) => {
        setLoading(false);

        if (error.response && error.response.status === 422) {
          if (error.response.data['remaining_credits'] !== undefined) {
            setRemainingCredits(error.response.data['remaining_credits']);
          } else {
            setRestrictedProperty(true);
          }
        }
      });
  }, []);

  if (loading) {
    return (
      <div className="text-center py-4">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  if (restrictedProperty) {
    return (
      <Row>
        <Col xs="auto">
          <FontAwesomeIcon className="p-4 bg-light border rounded" icon={faLock} />
        </Col>
        <Col>
          <Row className="flex-column gap-3">
            <Col>
              <div className="fs-large fw-bolder">Unlock access to see the owner of this property.</div>
              Looks like you don't have access to this property.
              Upgrade your account today to gain access to more properties and owners to grow your business.
            </Col>
            <Col>
              <Button href="/connect/profile/premium_signup" variant="secondary">Upgrade Account</Button>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }

  return <div>you have {remainingCredits} credits</div>; // Placeholder
}

UnlockOwners.propTypes = {
  insightsPropertyId: PropTypes.number.isRequired,
  onUnlock: PropTypes.func.isRequired
};
